import styled from 'styled-components';

export const Container = styled.div`
  margin: 1.5rem 0 0 0;
`;
